import { useEffect, useState } from "react"

import { useAccount, useSchedule } from "@shared/contexts"
import { getRef } from "@shared/modules"
import { toTimestamp } from "@shared/modules"

import { Vod } from "vod/contexts"

import { Message } from "./useMessages"
import {GROUP} from "../config";

interface Props {
  vod: Vod | null
}

export default function useVodMessages({ vod }: Props) {
  const { account } = useAccount()
  const { schedule } = useSchedule()

  const [messages, setMessages] = useState<Message[]>([])
  const [messageBucket, setMessageBucket] = useState<MessageBucket>({})

  const fbUniqueId = account.currentUser?.uid

  useEffect(() => {
    if (!vod || !schedule || !fbUniqueId) return

    const messageRef: firebase.database.Reference = getRef("messages").child(
      schedule.key,
    )
    messageRef
      .orderByChild("timestamp")
      .startAt(toTimestamp(vod.recordStartDate))
      .endAt(toTimestamp(vod.recordEndDate))
      .once("value", (snapshot: firebase.database.DataSnapshot) => {
        const messages = snapshot.val()
        if (!messages) return

        setMessages(
          Object.keys(messages).map((key) => {
            let message: Message = messages[key]
            message.key = key
            message.beautifulBody = message.body
            return message
          }),
        )
      })
  }, [vod, schedule, fbUniqueId])

  useEffect(() => {
    if (!messages || !messages.length || !vod) return

    let messageBucket: MessageBucket = {}
    messages.forEach((message, i) => {
      if (!message.timestamp) return
      // 일반사용자가 emoji 사용시 VOD 채팅에 미노출.
      if (!GROUP.STREAMER.includes(message.role) && message.emoji) return

      let second = Math.floor(
        (message.timestamp - toTimestamp(vod!.recordStartDate)) / 1000,
      )

      if (!messageBucket.hasOwnProperty(second)) {
        messageBucket[second] = [message]
        return
      }
      messageBucket[second].push(message)
    })

    setMessageBucket(messageBucket)
  }, [messages, vod])

  return { messageBucket }
}

interface MessageBucket {
  [key: number]: Message[]
}
